import { SETUP_FEATURES } from './recommendationConfig/setup'

const EXACT_DESCRIPTION_PHRASES = new Set(['api', 'crm'])

const normalizeText = value =>
    String(value || '')
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')

const getMatchedPhrases = (description, phrases) => {
    const normalizedDescription = normalizeText(description)
    const descriptionWords = new Set(normalizedDescription.split(/[^\p{L}\p{N}]+/u).filter(Boolean))

    return phrases.filter(phrase => {
        const normalizedPhrase = normalizeText(phrase)
        return EXACT_DESCRIPTION_PHRASES.has(normalizedPhrase)
            ? descriptionWords.has(normalizedPhrase)
            : normalizedDescription.includes(normalizedPhrase)
    })
}

/**
 * Returns product setup recommendations for an event brief. Related choices
 * map to one capability so the result remains a compact, actionable checklist.
 */
export const recommendEventSetup = ({ selectedTileIds = [], description = '' } = {}) => {
    const selectedIds = new Set(selectedTileIds)

    return SETUP_FEATURES.map(feature => {
        const matchedTileIds = feature.tileIds.filter(tileId => selectedIds.has(tileId))
        const matchedPhrases = getMatchedPhrases(description, feature.descriptionPhrases)
        const isExcluded = (feature.excludeWhenTileIds || []).some(tileId => selectedIds.has(tileId))

        return {
            ...feature,
            matchedTileIds,
            matchedPhrases,
            score: isExcluded ? 0 : matchedTileIds.length * 10 + matchedPhrases.length,
        }
    })
        .filter(feature => feature.score > 0)
        .sort((firstFeature, secondFeature) => {
            if (secondFeature.score !== firstFeature.score) return secondFeature.score - firstFeature.score
            return firstFeature.order - secondFeature.order
        })
}
